import { MarksWithImageStoryblok } from 'storyblok-types';

export enum HelpersType {
  MANUAL = 'manual',
  NEUTRAL_SHIPPING = 'neutralShipping',
  FREE_SHIPPING = 'freeShipping',
  MONEY_BACK = 'moneyBack',
  PRICE_WARRANTY = 'priceWarranty',
  YEARS_WARRANTY = 'yearsWarranty',
}

export enum VERSION {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}

interface IArea {
  fieldValue?: string;
  unit: 'px' | '%';
  x: number;
  y: number;
  width: number;
  height: number;
  id: string;
}

export type MarksWithImage = Record<
  'desktop' | 'tablet' | 'mobile',
  {
    asset: { filename: string };
    areas: IArea[];
  }
> &
  Pick<MarksWithImageStoryblok, 'startDate' | 'expirationDate'>;
